import React, { useEffect } from 'react';
import { Stack, Dialog, DialogActions, DialogContent, Grid } from '@mui/material';
import { MyButton, MyTypography } from '../../../common/components';
import RegisterUserForm, {
  initialValues,
  registerUserValidationSchema,
} from '../../../auth/RegisterUser/RegisterUserForm';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { gridSpacing } from '../../../../common/themes/constants';
import Swal from 'sweetalert2';
import clientGraphql from '../../../../common/apollo-graphql';
import { useMutation } from '@apollo/client';
import { SAVE_CLINIC_USER_MUTATION } from '../../gql/Mutation';

const validationSchema = registerUserValidationSchema;

export default function AddClinicUserDialog({ open, onClose, clinicId, providers = [] }) {
  
  const [
    save_clinic_user,
    { data: saveClinicUserData, loading: saveClinicUserLoading, error: saveClinicUserError },
  ] = useMutation(SAVE_CLINIC_USER_MUTATION, {
    client: clientGraphql,
  });

  const {
    handleSubmit,
    control,
    setValue,
    trigger,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...initialValues,
    },
    resolver: yupResolver(validationSchema),
    shouldFocusError: true,
    reValidateMode: 'onChange',
  });

  const onSubmit = async (formData) => {
    const newData = { ...formData };

    try {
      await save_clinic_user({
        client: clientGraphql,
        variables: { clinic_id: clinicId, user: newData },
      });
    } catch (error) {}
  };

  useEffect(() => {
    if (saveClinicUserError) {
      const graphQLError = saveClinicUserError?.graphQLErrors?.[0];
      const validation = graphQLError?.extensions?.validation;

      if (validation) {
        const validationString = JSON.stringify(validation);

        let message = validationString;
        if (validationString.includes('email')) {
          message = 'A user with this email already exists';
        } else if (validationString.includes('phone')) {
          message = 'A user with this phone number already exists';
        }

        Swal.fire({
          icon: 'error',
          text: message,
          showConfirmButton: true,
        });
      } else {
        Swal.fire({
          icon: 'error',
          text: `Error Message: ${saveClinicUserError.message}`,
          showConfirmButton: true,
        });
      }
    }

    if (saveClinicUserData) {
      Swal.fire({
        icon: 'success',
        text: 'Successfully created a user',
        showConfirmButton: true,
      }).then(() => {
        reset();
        onClose(true);
      });
    }
  }, [saveClinicUserData, saveClinicUserError, onClose, reset]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Dialog open={open} onClose={onClose} disablePortal={true}>
        <DialogContent>
          <Grid container direction="column" spacing={gridSpacing}>
            <Grid item xs={10}>
              <MyTypography variant="h3">Add User</MyTypography>
            </Grid>
            <Grid item xs={10}>
              <RegisterUserForm
                control={control}
                errors={errors}
                providers={providers}
                setValue={setValue}
                trigger={trigger}
                permissions={[]}
                watch={watch}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 4, pb: 3 }}>
          <Stack direction="row" justifyContent="flex-end" spacing={1}>
            <MyButton onClick={onClose} disabled={saveClinicUserLoading} fullWidth={false}>
              Cancel
            </MyButton>
            <MyButton
              type="submit"
              variant="contained"
              loading={saveClinicUserLoading}
              fullWidth={false}
            >
              Add User
            </MyButton>
          </Stack>
        </DialogActions>
      </Dialog>
    </form>
  );
}
